import React from "react";
import { Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { MdVerified } from "react-icons/md";
import { GoUnverified } from "react-icons/go";
import Pagination from "../../../helper/Pagination";

const UserDetailsTable = ({
  users,
  loading,
  searchTerm,
  handleSearchChange,
  currentPage,
  pagination,
  setCurrentPage,
}) => {
  return (
    <div className="table-section">
      <div className="d-flex justify-content-end align-items-center mb-2">
        <div className="d-flex gap-3">
          <div className="position-relative">
            <input
              type="search"
              placeholder="Search Users..."
              className="form-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "200px" }}
            />
            {searchTerm === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  color: "#666",
                  transform: "translateY(-50%)",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="table-scroll-wrapper">
        <table className="partners-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Full Name</th>
              <th>Email</th>
              <th>Domain</th>
              <th>Status</th>
              <th>Email Verified</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#666",
                  }}
                >
                  <div className="loading-spinner">
                  </div>
                </td>
              </tr>
            ) : !users || users.length === 0 ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#666",
                  }}
                >
                  No users found
                </td>
              </tr>
            ) : (
              users.map((user, index) => (
                <tr key={user._id}>
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td>
                    {user.firstName && user.lastName
                      ? `${user.firstName} ${user.lastName}`
                      : user.firstName || user.lastName || "N/A"}
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <span
                        title={user.email}
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          maxWidth: '200px'
                        }}
                      >
                        {user.email || "N/A"}
                      </span>
                      {user.verified !== undefined && (
                        <span className="ms-2">
                          {user.verified ? (
                            <MdVerified
                              style={{
                                color: "#28a745",
                                fontSize: "16px",
                              }}
                              title="Email Verified"
                            />
                          ) : (
                            <GoUnverified
                              style={{
                                color: "#dc3545",
                                fontSize: "16px",
                              }}
                              title="Email Not Verified"
                            />
                          )}
                        </span>
                      )}
                    </div>
                  </td>
                  <td>{user.domain || "N/A"}</td>
                  <td>
                    <span
                      className={`badge ${
                        user.status === "active" ? "bg-success" : "bg-secondary"
                      }`}
                      style={{
                        background: user.status === 'active' 
                          ? 'bg-success' 
                          : 'bg-danger'
                      }}
                    >
                      {user.status?.toUpperCase() || "UNKNOWN"}
                    </span>
                  </td>
                  <td>
                    {user.verified !== undefined ? (
                      user.verified ? (
                        <span className="text-success">Verified</span>
                      ) : (
                        <span className="text-danger">Not Verified</span>
                      )
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>
                    {user.createdAt
                      ? new Date(user.createdAt).toLocaleDateString()
                      : "N/A"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {pagination && pagination.totalPages > 1 && (
        <div className="pagination-section p-3 border-top">
          <Pagination
            currentPage={currentPage}
            totalPages={pagination.totalPages}
            totalItems={pagination.totalItems}
            itemsPerPage={pagination.itemsPerPage}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

export default UserDetailsTable;